import { fileNameFromUrl } from 'common/services/fileurls';

import { TopicCardAvailableAttachmentOptions } from 'data/models/TopicCardAvailableAttachment';
import { TopicCardTemplateAttachment as ServerTopicCardTemplateAttachment } from 'server/models/TopicCardTemplateAttachment';

export { TopicCardTemplateAttachmentData, TopicCardTemplateAttachmentOptions } from 'server/models/TopicCardTemplateAttachment';

export class TopicCardTemplateAttachment extends ServerTopicCardTemplateAttachment {
    FileName() {
        return fileNameFromUrl(this.AttachmentUrl());
    }
}


// WEBPACK FOOTER //
// ./data/models/TopicCardTemplateAttachment.ts